import {getNoAuthRFPApi } from './common/apis';

export default class AnswerOptionsService {
    async getOptions() {
        try {
            const response = await getNoAuthRFPApi(`api/v1/industry`);
            return response;
        } catch (error) {
            console.error('Error fetching options:', error);
            throw error;
        }
    }


}
